import React from 'react';
import EditorApp from '../editor/EditorApp';
import GoLiveHelperDownloadApp from '../live/GoLiveHelperDownloadApp';
import LiveControlApp from '../live/LiveControlApp';
import OutputApp from '../output/OutputApp';
import resolveAppMode from './resolveAppMode';

const AppRoot = () => {
  const mode = resolveAppMode(typeof window === 'undefined' ? '' : window.location.search);

  if (mode === 'live') return <LiveControlApp />;
  if (mode === 'output') return <OutputApp />;
  if (mode === 'helper-download') return <GoLiveHelperDownloadApp />;
  return <EditorApp />;
};

export default AppRoot;
